// write context api code for admin
import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import axiosAPI from "../../../config/axiosInstance";

const AdminContext = createContext();
export const AdminProvider = ({ children }) => {
  const [companies, setcompanies] = useState([]);
  const [allowUser, setallowUser] = useState(false);

  const [viewStack, setViewStack] = useState(["companies"]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [companyProjects, setCompanyProjects] = useState([]);
  const [projectWorkflows, setProjectWorkflows] = useState([]);

  // Example function to fetch admin data
  const fetchAdminData = async () => {
    try {
      const response = await axiosAPI("GET", "admin/data");
      console.log("🚀 ~ :15 ~ fetchAdminData ~ response:", response);
      setcompanies(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch admin data", { autoClose: 2000 });
    }
  };

  const fetchCompanyUsers = async (companyId) => {
    try {
      const response = await axiosAPI(
        "GET",
        `admin/companies/${companyId}/users`
      );
      setCompanyUsers(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch company users", { autoClose: 2000 });
    }
  };

  const fetchCompanyProjects = async (companyId) => {
    try {
      const response = await axiosAPI(
        "GET",
        `admin/companies/${companyId}/projects`
      );
      setCompanyProjects(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch company projects", { autoClose: 2000 });
    }
  };

  const fetchProjectWorkflows = async (projectId) => {
    try {
      const response = await axiosAPI(
        "GET",
        `admin/projects/${projectId}/workflows`
      );
      setProjectWorkflows(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch project workflows", { autoClose: 2000 });
    }
  };

  const openCompany = (company) => {
    setSelectedCompany(company);
    setViewStack(["companies", "companyDetail"]);
    fetchCompanyUsers(company._id);
    fetchCompanyProjects(company._id);
  };

  const openUsers = () => {
    setViewStack(["companies", "companyDetail", "users"]);
  };

  const openProjects = () => {
    setViewStack(["companies", "companyDetail", "projects"]);
  };

  const openProjectWorkflows = (project) => {
    setSelectedProject(project);
    setViewStack(["companies", "companyDetail", "projects", "workflows"]);
    fetchProjectWorkflows(project._id);
  };

  const goBack = () => {
    setViewStack((prev) => {
      if (prev.length <= 1) return prev;
      const next = prev.slice(0, -1);
      const current = next[next.length - 1];
      if (current === "companies") {
        setSelectedCompany(null);
      }
      if (current !== "workflows") {
        setSelectedProject(null);
      }
      return next;
    });
  };

  const login = async (passcode) => {
    try {
      const validatePasscode = await axiosAPI(
        "POST",
        "admin/validate-passcode",
        { passcode }
      );

      if (validatePasscode.status) {
        await fetchAdminData();
        setallowUser(true);
        toast.success("Login successful!", { autoClose: 2000 });
        return true;
      } else {
        setallowUser(false);
        return false;
      }
    } catch (error) {
      toast.error("Login failed. Please try again.", { autoClose: 2000 });
      return false;
    }
  };

  const adminData = {
    companies,
    allowUser,

    login,
    setallowUser,

    viewStack,
    selectedCompany,
    selectedProject,
    companyUsers,
    companyProjects,
    projectWorkflows,

    openCompany,
    openUsers,
    openProjects,
    openProjectWorkflows,
    goBack,
  };

  return (
    <AdminContext.Provider value={adminData}>{children}</AdminContext.Provider>
  );
};

// Custom Hook to use the context
export const useAdminContext = () => {
  return useContext(AdminContext);
};
